import { render, staticRenderFns } from "./GCPinf.vue?vue&type=template&id=21ba694d&"
import script from "./GCPinf.vue?vue&type=script&lang=js&"
export * from "./GCPinf.vue?vue&type=script&lang=js&"
import style0 from "./GCPinf.vue?vue&type=style&index=0&id=21ba694d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports